var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGalleryTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 34,
    viewBox: "0 0 70 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0L12 6H20L16 0Z",
    fill: "#0D101A",
    fillOpacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 70,
    height: 28,
    rx: 4,
    fill: "#0D101A",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.684 24.768V24.012H11.336V22.884H17.3V20.328H10.352V21.096H16.376V22.188H10.424V24.768H17.684ZM17.3 19.8V14.352H16.388V16.788H15.056V14.544H14.18V19.716H15.056V17.556H16.388V19.8H17.3ZM13.004 14.964H8.984V15.72H12.032C11.84 17.256 10.508 18.708 8.48 19.392L9.068 20.1C11.24 19.188 12.92 17.628 13.004 14.964ZM27.0948 24.84V14.352H26.1828V18.444H24.2988V19.224H26.1828V24.84H27.0948ZM24.4908 21.252C23.1828 21.48 21.1788 21.576 19.8108 21.576V19.032H23.6748V15.348H18.8988V16.104H22.7628V18.264H18.8988V22.356H19.6548C21.2148 22.356 23.5068 22.2 24.5868 22.008L24.4908 21.252ZM36.3256 14.352V24.84H37.2376V14.352H36.3256ZM35.3656 21.228C34.0936 21.456 32.0176 21.552 30.3496 21.552H30.0976V19.044H34.0816V15.324H29.1376V16.08H33.1576V18.288H29.1856V22.332H30.2536C32.5576 22.332 34.3576 22.152 35.4496 21.984L35.3656 21.228ZM49.8728 20.628V15.072H48.9608V17.004H43.6208V15.072H42.6968V20.628H45.8168V22.764H41.5568V23.532H51.0248V22.764H46.7288V20.628H49.8728ZM48.9608 19.872H43.6208V17.76H48.9608V19.872ZM60.2076 24.84V14.352H59.2956V24.84H60.2076ZM57.1236 15.468H52.1316V16.236H56.1516C55.9596 18.6 54.3996 20.88 51.7476 22.044L52.2756 22.764C54.9876 21.48 57.0756 18.876 57.1236 15.468Z",
    fill: "#F6F7F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryTooltip);
export default __webpack_public_path__ + "static/media/galleryTooltip.89c7d23a32fd52f3a2646983df51ea0f.svg";
export { ForwardRef as ReactComponent };